import React from "react";
import { connect } from "react-redux";
import config from "config";

import {
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
} from "@ionic/react";

export interface Props {
  quizData: Quiz;
  state: any;
}

const Debug: React.FC<Props> = ({ state, quizData }) => {
  const { quizConfig } = quizData;
  const progress:any = quizData.progress

  let debugState = { ...state, quiz: { ...state.quiz, quizConfig: {} } };

  return (
    <>
      {config.TEST_MODE && quizConfig && quizConfig.format && (
        <>
          <IonCard>
            <IonCardHeader>
              <IonCardTitle>Progress Debug</IonCardTitle>
              <IonCardSubtitle>
                This does not appear in production build
              </IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <>
                <div>Round: {progress.round}</div>
                <div>Position: {progress.position}</div>
                <div>Section: {progress.section}</div>
                <div>Page: {progress.page}</div>
                {/* <div>isAnswer: {progress?.isAnswer?.toString()}</div>
                <div>
                  showBreakerAnswer: {progress?.showBreakerAnswer?.toString()}
                </div> */}
                <div>configRounds: {quizConfig.format.rounds}</div>
                <div>
                  isCrossword: {quizConfig.format.isCrossword?.toString()}
                </div>
                <div>assignedPrizes: {quizData.assignedPrizes.length}</div>
              </>
            </IonCardContent>
          </IonCard>
          <IonCard>
            <IonCardHeader>
              <IonCardTitle>App State</IonCardTitle>
              <IonCardSubtitle>
                This does not appear in production build
              </IonCardSubtitle>
            </IonCardHeader>
            <IonCardContent>
              <div>
                <pre>{JSON.stringify(debugState.user, null, 2)}</pre>
                <pre>{JSON.stringify(debugState.quiz, null, 2)}</pre>
              </div>
            </IonCardContent>
          </IonCard>
        </>
      )}
    </>
  );
};

const mapStateToProps = (state: any) => ({
  state: state,
  user: state.user,
  quizData: state.quiz,
  teams: state.teams.teams,
  ccConnected: state.general.ccConnected,
});

export default connect(mapStateToProps, {})(Debug);
